export default {
    data() {
        return {
            shippingOptions: [
                { value: 'Media Mail', text: 'Media Mail' },
                { value: 'Priority Mail', text: 'Priority Mail' },
                { value: 'First Class Mail', text: 'First Class Mail' },
                { value: 'Air Mail', text: 'Air Mail' },
                { value: 'Local Pickup', text: 'Local Pickup' },
                { value: 'Surface Mail', text: 'Surface Mail', disabled: true },
                { value: 'Canada Air', text: 'Canada Air', disabled: true },
                { value: 'Economy Air', text: 'Economy Air', disabled: true },
                { value: 'Registered', text: 'Registered', disabled: true },
                { value: 'Express Mail', text: 'Express Mail', disabled: true },
            ],
        }
    }
}